import type { ReactNode } from 'react';

import { toast } from 'sonner';

import { Toast } from './Toast';

import type { ToastVariant } from './types';
import type { ExternalToast } from 'sonner';

type ToastFn = (message: ReactNode, options?: ExternalToast) => string | number;

export const TOAST_DURATION = 5_000;

const showToast =
  (variant: ToastVariant): ToastFn =>
  (message, options) =>
    toast.custom(
      (id) => (
        <Toast
          message={message}
          variant={variant}
          onClose={() => toast.dismiss(id)}
        />
      ),
      options,
    );

export const notifications: Record<ToastVariant | 'custom', ToastFn> = {
  error: showToast('error'),
  info: showToast('info'),
  success: showToast('success'),
  warning: showToast('warning'),
  custom: (message, options) =>
    toast.custom(() => <>{message}</>, { unstyled: true, ...options }),
};
